<template lang="pug">
	.network-show--detail.flex-col.full-width(:class="{ 'disabled-controls': isDeleting }")
		Loader(v-if="isLoading", :text="$tCaption('Loading', '@actions') + '..'", :fullscreen="true")
		.content(v-if="show")
			.flex-col.space-medium.padding
				.flex-row.justify
					.flex-row.space-medium.align-center.wrap
						.flex-row.space.align-center.font-big.upper.grey
							a.nowrap(@click="$router.push({ path: '/network-studio/shows' })") {{$tCaption('Network shows')}}
							span /
							span {{show.Name || $tCaption('Show')}}
						.flex-row.space-medium.align-center
							DxButton(:text="$tCaption('New episode')", type="normal", icon="plus", @click="$refs.newEpisode.show()")
							Loader(v-if="isSaving", text="")
					.flex-row.space-medium.align-center
						Switcher.font-lg.nowrap(:value="!!show.Status", @change="v => show.Status = v ? 1 : 0", :text="show.Status ? $tCaption('Published') : $tCaption('Not published')", :beforeChange="beforeStatusChange")
						DxButton(:text="$tCaption('Delete')", type="danger", icon="trash", @click="deleteShow", stylingMode="text")
				.flex-row(:class="{ 'disabled-controls': readonly }")
					NavigatorMenu(:items="menuItems", @change="v => setActiveMenuItem(v)", :activeItemId="activeMenuItem")
					.flex-1(v-if="activeMenuItem === 'basic'")
						.padding.flex-1
							.flex-row.space-large.align-start
								.flex-col
									.flex-row
										.adt-tab.small.no-border.top.flex-1(@click="imageTab = 'logo'", :class="{ active: imageTab === 'logo' }") {{$tCaption('Logo')}}
										.adt-tab.small.no-border.top.flex-1.clickable(@click="imageTab = 'picture'", :class="{ active: imageTab === 'picture' }") {{$tCaption('Picture')}}
									ImageEditor(v-if="imageTab === 'picture'", :objectId="show.Oid", :objectType="$Data.objectTypes.NetworkShow", :url="show.PictureUrl", size="130px", fieldName="Picture", :cropSizes="[640, 640]")
									ImageEditor(v-if="imageTab === 'logo'", :objectId="show.Oid", :objectType="$Data.objectTypes.NetworkShow", :url="show.LogoUrl", size="130px", fieldName="Logo", :cropSizes="[256, 256]")
								.flex-col.space-large.flex-1
									.flex-row.space.wrap
										EditableLabelField(:caption="$tCaption('Name')", :value.sync="show.Name", type="text", stylingMode="filled")
										EditableLabelField(:caption="$tCaption('Subname')", :value.sync="show.Subname", type="text", stylingMode="filled")
									EditableLabelField(:caption="$tCaption('Description')", :value.sync="show.Description", type="area", stylingMode="filled")
									.flex-row.space.wrap
										EditableLabelField(:caption="$tCaption('Start date')", :value.sync="show.Schedule.StartDate", type="date", stylingMode="filled")
										EditableLabelField(:caption="$tCaption('End date')", :value.sync="show.Schedule.EndDate", type="date", stylingMode="filled")
										EditableLabelField(:caption="$tCaption('Time zone')", :value.sync="show.TimeZoneId", type="dropdown", stylingMode="filled")
											Dropdown( slot="editor", :getTotal="(data) => data.TotalNumberOfRecords", :getItems="(data) => data.Results", :getData="$Data.getTimeZones", 
												:columns="[{ dataField: 'DisplayName', caption: $tCaption('Time zone') }]", displayExpr="DisplayName", valueExpr="Id", :selectedItems="show.TimeZoneId",
												:showColumnHeaders="false", :filtersVisible="false", :searchVisible="true", :multiple="false", :minSearchLength="0", stylingMode="filled",
												@select-data="item => show.TimeZoneId = item ? item.Id : null"
											)
									.flex-row.space-large
										.flex-col.space.flex-1
											.font-small.upper.grey {{$tCaption('Recurrence')}}
											RRuleField.font-big(:value="show.Schedule.RecurrencePattern", :editable="true", @save="v => show.Schedule.RecurrencePattern = v")
										.flex-col.space.flex-1
											.font-small.upper.grey {{$tCaption('Voicebox number')}}
											.font-big(v-if="show.VoiceboxNumber") {{show.VoiceboxNumber}}
											.flex-row.space.align-center(v-else)
												DxButton(:text="$tCaption('Generate')", @click="generateVoiceboxNumber", :disabled="states['generateVoicebox']", icon="fas fa-wand-magic-sparkles")
												Loader(v-if="states['generateVoicebox']", text="")
										.flex-1
									.flex-row.space.wrap
										EditableLabelField(:caption="$tCaption('Show reel video (url)')", :value.sync="show.ShowReelVideoUrl", type="text", stylingMode="filled")
									.flex-col.space(:class="{ 'disabled-controls': states['showRealLoading'] }")
										.font-small.upper.grey {{$tCaption('Show reel audio')}}
										.flex-row.space.align-center
											Loader(v-if="states['showRealLoading']", text="")
											DxButton(v-if="show.ShowReelAudio", :text="showReelDownloadText", @click="downloadShowReelAudio", icon="download", :disabled="states['showRealDownloading']")
											FileUploader(:text="$tCaption('Upload')", icon="upload" @upload="onShowReelAudioUpload", :dropText="$tCaption('Or drop audio files here to upload')", :accept="['.mp3','.wav','.ogg']")
					.flex-1(v-if="activeMenuItem === 'social'")
						.padding.flex-1.flex-col.space-medium
							.flex-row.space-medium
								EditableLabelField(:caption="$tCaption('Facebook')", :value.sync="show.Facebook", type="text", stylingMode="filled", icon="fa-brands fa-facebook")
								EditableLabelField(:caption="$tCaption('Linkedin')", :value.sync="show.Linkedin", type="text", stylingMode="filled", icon="fa-brands fa-linkedin")
							.flex-row.space-medium
								EditableLabelField(:caption="$tCaption('Facebook')", :value.sync="show.Twitter", type="text", stylingMode="filled", icon="fa-brands fa-twitter")
								EditableLabelField(:caption="$tCaption('Linkedin')", :value.sync="show.Instagram", type="text", stylingMode="filled", icon="fa-brands fa-instagram")
							EditableLabelField(:caption="$tCaption('Website')", :value.sync="show.Website", type="text", stylingMode="filled", icon="globe")
							EditableLabelField(:caption="$tCaption('Podcast URL')", :value.sync="show.PodcastURL", type="text", stylingMode="filled", icon="podcast")
					.flex-1(v-if="activeMenuItem === 'contacts'")
						.padding.flex-1.flex-col.space-large
							EditableLabelField(ref="affContact", :caption="$tCaption('Affiliate sales contact')", :value.sync="show.AffiliateSalesContact", type="area", stylingMode="filled", icon="fa-solid fa-user-tie")
							EditableLabelField(ref="advContact", :caption="$tCaption('Advertising sales contact')", :value.sync="show.AdvertisingSalesContact", type="area", stylingMode="filled", icon="fa-brands fa-adversal")
							EditableLabelField(ref="techContact", :caption="$tCaption('Technical contact')", :value.sync="show.TechnicalContact", type="area", stylingMode="filled", icon="fa-solid fa-user-gear")
					.flex-1(v-if="activatedMenuItems['talents']", v-show="activeMenuItem === 'talents'")
						.padding.flex-1.flex-col.space-large
							ListViewLinkUnlink(:rootItemId="show.Oid", :rootObjectTypeId="$Data.objectTypes.NetworkShow", :allItemsRequest="$Data.getNetworkShowTalents", :linkedItemsRequest="$Data.getNetworkShowLinkedTalents", collectionField="Talents",
								:saveAction="$Data.createUpdateNetworkShowTalent", :deleteAction="$Data.deleteNetworkShowTalent", :newItemResolver="() => getNewItem('talent')", :newItemPopupSizes="[640, 520]", :searchPanelWidth="480")
								template(slot="left-actions")
									.font-big.upper.grey {{$tCaption('Talents')}}
								template(v-slot:item="data")
									TalentDetail(v-bind="data")
					.flex-1(v-if="activatedMenuItems['categories']", v-show="activeMenuItem === 'categories'")
						.padding.flex-1.flex-col.space-large
							ListViewLinkUnlink(:rootItemId="show.Oid", :rootObjectTypeId="$Data.objectTypes.NetworkShow", :allItemsRequest="$Data.getNetworkShowCategories", :linkedItemsRequest="$Data.getNetworkShowLinkedCategories", collectionField="Categories",
								:saveAction="$Data.createUpdateNetworkShowCategory", :deleteAction="$Data.deleteNetworkShowCategory", :newItemResolver="() => getNewItem('categories')", :newItemPopupSizes="[440, 170]", unlinkAlign="left")
								template(slot="left-actions")
									.font-big.upper.grey {{$tCaption('Categories')}}
								template(v-slot:item="data")
									NameDetail(v-bind="data")
					.flex-1(v-if="activatedMenuItems['formats']", v-show="activeMenuItem === 'formats'")
						.padding.flex-1.flex-col.space-large
							ListViewLinkUnlink(:rootItemId="show.Oid", :rootObjectTypeId="$Data.objectTypes.NetworkShow", :allItemsRequest="$Data.getNetworkShowFormats", :linkedItemsRequest="$Data.getNetworkShowLinkedFormats", collectionField="Formats",
								:saveAction="$Data.createUpdateNetworkShowFormat", :deleteAction="$Data.deleteNetworkShowFormat", :newItemResolver="() => getNewItem('formats')", :newItemPopupSizes="[440, 170]", unlinkAlign="left")
								template(slot="left-actions")
									.font-big.upper.grey {{$tCaption('Formats')}}
								template(v-slot:item="data")
									NameDetail(v-bind="data")
					.flex-1.padding(v-if="activatedMenuItems['clocks']", v-show="activeMenuItem === 'clocks'")
						ClocksList(:networkShowId="show.Oid")
					.flex-1.padding(v-if="activatedMenuItems['cues']", v-show="activeMenuItem === 'cues'")
						CuesList()
					.flex-1.padding(v-if="activatedMenuItems['episodes']", v-show="activeMenuItem === 'episodes'")
						EpisodesList(:networkShowId="show.Oid")
			NetworkShowNewEpisode(ref="newEpisode", :networkShowId="show.Oid")
</template>

<script>
	import _ from 'lodash';
	import Loader from 'app-core/Loader.vue';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxTextArea from 'devextreme-vue/text-area';
	import NavigatorMenu from 'app-core/NavigatorMenu.vue';
	import EditableLabelField from 'app-core/EditableLabelField.vue';
	import ImageEditor from 'app-core/ImageEditor.vue';
	import DxTabPanel from 'devextreme-vue/tab-panel';
	import FileUploader from 'app-core/FileUploader.vue';
	import Dropdown from 'app-core/Dropdown.vue';
	import ListViewLinkUnlink from 'app-core/ListViewLinkUnlink.vue';
	import TalentDetail from './TalentDetail.vue';
	import NameDetail from './NameDetail.vue';
	import ClocksList from './ClocksList.vue';
	import CuesList from './CuesList.vue';
	import EpisodesList from './EpisodesList.vue';
	import NetworkShowNewEpisode from './NewEpisode.vue';
	import RRuleField from 'app-core/RRuleField.vue';
	import Switcher from 'app-core/Switcher.vue';

	export default {
		translationCategory: 'networkShow.Detail',
		name: 'network-show--detail',
		props: ['id'],
		components: { 
			Loader, DxTextBox, DxTextArea, NavigatorMenu, EditableLabelField, ImageEditor, DxTabPanel, FileUploader, DxButton, Dropdown, 
			ListViewLinkUnlink, TalentDetail, NameDetail, ClocksList, CuesList, EpisodesList, NetworkShowNewEpisode, RRuleField, Switcher
		},
		data() {
			return {
				show: null,
				isLoading: false,
				menuItems: [
					{ id: 'basic', name: this.$tCaption('Basic info'), icon: 'circle-info', subItems: [
						{ id: 'social', name: this.$tCaption('Media & social'), icon: 'square-share-nodes' },
						{ id: 'contacts', name: this.$tCaption('Contacts'), icon: 'id-badge' },
						{ id: 'talents', name: this.$tCaption('Talents'), icon: 'users-rectangle' },
						{ id: 'categories', name: this.$tCaption('Categories'), icon: 'layer-group' },
						{ id: 'formats', name: this.$tCaption('Formats'), icon: 'list' },
						{ id: 'cues', name: this.$tCaption('Net cues'), icon: 'bookmark' },
					]},
					{ id: 'clocks', name: this.$tCaption('Clocks'), icon: 'clock' },
					{ id: 'episodes', name: this.$tCaption('Episodes'), icon: 'diamond' },
				],
				activeMenuItem: 'basic',
				imageTab: 'logo',
				isSaving: 0,
				isLoaded: false,
				states: {},
				isDeleting: false,
				activatedMenuItems: {}
			};
		},
		computed: {
			readonly() {
				return false;
			},
			showReelDownloadText() {
				return this.$tCaption('Download audio') + (this.show.ShowReelAudio?.Duration ? ` (${parseInt(this.show.ShowReelAudio?.Duration / 1000)} ${this.$tCaption('sec.')})` : '');
			}
		},
		watch: {
			show: {
				handler() {
					if (!this.$preventChangesHandle) {
						this.save();
					}
				},
				deep: true
			}
		},
		mounted() {
			if (__DEBUG__)
				window.networkShowDetail = this;
			if (this.id !== 'new') {
				this.loadShow();
			} else {
				this.createNewShow();
			}
		},
		destroyed() {
			delete this.$preventChangesHandle;
		},
		methods: {
			generateVoiceboxNumber() {
				this.setState('generateVoicebox', true);
				this.$Data.postExternalApi('NetworkShow/GenerateVoiceboxNumber', { Id: this.show.Oid, Type: this.$Data.objectTypes.NetworkShow })
					.then((r) => {
						if (r?.Data) {
							this.$set(this.show, 'VoiceboxNumber', r?.Data);
						}
					})
					.finally(() => {
						this.setState('generateVoicebox', false)
					});
			},
			async beforeStatusChange() {
				if (!this.show.Status) {
					return true;
				} else {
					return this.$confirm(void 0, this.$tCaption('Network show won\'t be public anymore. Continue?'));
				}
			},
			getNewItem(type) {
				switch(type) {
					case 'talent':
						return {
							Bio: null,
							Facebook: null,
							Linkedin: null,
							Twitter: null,
							Instagram: null,
							TikTok: null,
							Name: null,
							Oid: null,
						};
					default: 
						return {
							Oid: null,
							Name: null
						}
				}
			},
			setActiveMenuItem(v) {
				this.activeMenuItem = v;
				this.$set(this.activatedMenuItems, v, true);
			},
			deleteShow() {
				this.$confirmMessage({
					title: this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('Do you want to remove network show?'),
					handler: () => {
						this.isDeleting++;
						this.$Data.postExternalApi('NetworkShow/Delete', [this.id]).finally(() => {
							this.isDeleting--;
							this.$router.push({ path: '/network-studio/shows' });
						});
					}
				});
			},
			downloadShowReelAudio() {
				const fileName = _.last(this.show.ShowReelAudio.FileName.split('_'));
				this.setState('showRealDownloading', true);
				this.$Data.downloadURI(this.show.ShowReelAudio.AzureFileUrl, fileName);
				setTimeout(() => this.setState('showRealDownloading', false), 2000);
			},
			setState(state, val) {
				this.$set(this.states, state, val);
			},
			getState(state) {
				return this.states[state];
			},
			loadShow() {
				this.isLoading++;
				this.$Data.getExternalApi('NetworkShow/Get', `id=${this.id}`).then(r => this.show = r).finally(() => {
					this.isLoading--;
					this.isLoaded = true;
				});
			},
			setPreventChangesHandle() {
				this.$preventChangesHandle = true;
				setImmediate(() => this.$preventChangesHandle = false);
			},
			createNewShow() {
				this.isLoading++;
				this.$Data.postExternalApi('NetworkShow/CreateUpdate', {}).then(r => {
					this.setPreventChangesHandle();
					this.show = r?.Data;
					this.isLoaded = true;
					this.$router.push({ path: `/network-studio/show/${r?.Data.Oid}` });
				}).finally(() => this.isLoading--);
			},
			save() {
				if (!this.show?.Oid || !this.isLoaded) return;
				if (this.isSaving > 0) {
					this.isSaving++;
					return;
				}
				this.isSaving++;
				this.$Data.postExternalApi('NetworkShow/CreateUpdate', this.show).then(r => {
					this.setPreventChangesHandle();
					if (this.isSaving === 1) {
						this.show = r?.Data;
					}
				}).finally(() => {
					this.isSaving--;
					if (this.isSaving > 0) {
						this.isSaving = 0;
						this.save();
					}
				});
			},
			onShowReelAudioUpload(files) {
				if (this.show.ShowReelAudio?.FileName) {
					this.$azure.removeBlob(this.show.ShowReelAudio?.FileName, this.show.ShowReelAudio?.AzureContainer);
				}

				var audio = new Audio();				
				audio.addEventListener('loadedmetadata', () => {
					this.isSaving++;
					this.setState('showRealLoading', true);
					return this.$azure.uploadBlobWithInfoResponse(`showReelAudio_${this.$Data.uuid()}_${files[0].name}`, files[0], 'show-media-assets').then(r => {
						if (__DEBUG__)
							console.debug('Show reel audio uploaded', { r, dur: audio?.duration });
						this.$set(this.show, 'ShowReelAudio', {
							...r,
							Duration: parseInt(audio.duration * 1000)
						});
					}).finally(() => {
						this.isSaving--;
						this.setState('showRealLoading', false);
					});
				});
				audio.src = URL.createObjectURL(files[0]);
			},
			newEpisode() {

			}
		}
	};
</script>
<style lang='scss'>
	.network-show--detail {
		.app-core--image-editor .image {
			margin: 0px !important;
			border-radius: 0px !important;
			border-radius: 0px 0px 4px 4px !important;
			border: 1px solid #efefef !important;
		}
	}
</style>
